import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import SidebarProvider from '../contexts/sidebar/Provider';

// components
import SignIn from '../views/Login/SignIn';
import ForgotPassword from '../views/Login/ForgotPassword';
import CreatePassword from '../views/Login/CreatePassword';
import Dashboard from '../views/Dashboard';
import NotFound from '../views/NotFound';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

const Routes = () => {
    return (
        <SidebarProvider>
            <Router>
                <Switch>
                    {/* Public Routes */}
                    <PublicRoute path='/' component={SignIn} exact />
                    <PublicRoute path='/login' component={SignIn} exact />
                    <PublicRoute path='/forgotpwd' component={ForgotPassword} exact />
                    <PublicRoute path='/createPwd/:token' component={CreatePassword} exact />
                    <PublicRoute path='/resetPwd/:token' component={CreatePassword} exact />
                    {/* Private Routes */}
                    <PrivateRoute path='/dashboard' component={Dashboard} />                    
                    {/* Alternative Route */}
                    <Route path='*' component={NotFound} exact /> 
                    <Redirect exact from='/' to='/' />
                </Switch>
            </Router> 
        </SidebarProvider>    
    );
}

export default Routes;